export class NoteSubCategory {
    public id: number;
    public noteCategoryId: number;
    public noteSubCategoryName: string;
}